import React, { useContext, useEffect, useState } from "react";
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import useGetAllCnaeEmployee from  '../../../../services/utils/useGetAllCnaeEmployee.'
import { ICnaeResponse } from "@solimat/solimat-web-endpoint/lib/utils/dto";
import { getRawFechaCNAE, getFechaCNAE } from '../../../../services/utils/fechaCNAEUtils';
// import { MasterDataContext } from "components/pages/Delta/Delta";
import masterDataUtils from "services/utils/masterDataUtils";
import { useFormContext } from "react-hook-form";
import Fuse from "fuse.js";
import DOMPurify from 'dompurify';

interface IInputProps {
  errors: any;
  register: any;
  watchCnaeCode?: any;
  setValue?: any;
  label?: string;
  placeholder?: string;
  idCode: string;
  idDescription: string;
  required?: boolean | string;
}
 

const CnaeContributionAtEp: React.FC<IInputProps> = ({
  errors,
  register,
  setValue,
  watchCnaeCode,
  label,
  idCode,
  idDescription,
  placeholder,
  required
}) => {
  const { getAllCnaeEmployee, watchFechaCNAE } = useGetAllCnaeEmployee();
  const [allCnae, setAllCnae] = useState<any[]>([]);
  const [localCnaeError, setLocalCnaeError] = useState<string>('');
  const [fechaCNAE, setFechaCNAE] = useState<string>('');


  const { getValues, setError, clearErrors, setValue: setFormValue } = useFormContext();

  useEffect(() => {
    // subscribe to fechaBaja changes and set local state
    setFechaCNAE(getFechaCNAE());
    const stop = watchFechaCNAE((fecha) => {
      setFechaCNAE(fecha);
    });
    return () => stop && stop();
  }, []);

  useEffect(() => {
    if (getRawFechaCNAE() === null)
      return;

    // when fechaCNAE changes, reload CNAE list and validate
    const handleLoad = async (fecha: string) => {
      const res = await getAllCnaeEmployee(fecha || '');
      if (res) {
        const newArr = Array.isArray(res) ? [...res] : (res as any[]);
        setAllCnae(newArr as any[]);
        const currentCodeRaw = getValues ? getValues(idCode) : '';
        const currentCode = (currentCodeRaw || '').toString().trim();
        if (currentCode) {
          const exists = (newArr as any[]).some((item: any) => {
            const codigo = (item?.Codigo ?? item?.code ?? '').toString().trim();
            return codigo === currentCode;
          });
          if (!exists) {
            if (setValue) {
              try { setValue(idCode, ""); } catch (e) {}
              try { setValue(idDescription, ""); } catch (e) {}
            } else {
              try { setFormValue(idCode, ""); } catch (e) {}
              try { setFormValue(idDescription, ""); } catch (e) {}
            }
            const errorMessage = `${currentCode} CNAE no existe`;
            try { setError && setError(idCode, { type: 'manual', message: errorMessage }); } catch (e) {}
            setLocalCnaeError(errorMessage);
          } else {
            try { clearErrors && clearErrors(idCode); } catch (e) {}
            setLocalCnaeError('');
          }
        }
      }
    };
    handleLoad(getFechaCNAE());
  }, [fechaCNAE]);

  useEffect(() => {
    setValueCnaeDescription();
  }, [watchCnaeCode, allCnae]);
  

  const handleChange = (args: any) => {
    if (!args.isInteracted) return;
    if (allCnae) {
      const selectedValue = allCnae.find(
        (item: any) => item.Descripcion === args.value
      );
      if (selectedValue) {
        setValue(idCode, selectedValue.Codigo || "");
        setValue(idDescription, selectedValue.Descripcion || "");
        try { clearErrors && clearErrors(idCode); } catch (e) {}
        try { clearErrors && clearErrors(idDescription); } catch (e) {}
        setLocalCnaeError('');
      } else {
        setValue(idCode, "");
        setValue(idDescription, "");
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value || "";
    const value = rawValue.trim();

    // siempre mantenemos en el formulario lo que el usuario va escribiendo
    setValue(idCode, value);

    if (value === "") {
      // código vacío: limpiamos descripción y errores, pero dejamos que vuelva a escribir
      setValue(idDescription, "");
      try { clearErrors && clearErrors(idCode); } catch (e) {}
      try { clearErrors && clearErrors(idDescription); } catch (e) {}
      setLocalCnaeError('');
      return;
    }

    // mientras no tenga la longitud completa, no validamos contra la lista
    if (value.length < 4) {
      setValue(idDescription, "");
      try { clearErrors && clearErrors(idCode); } catch (e) {}
      try { clearErrors && clearErrors(idDescription); } catch (e) {}
      setLocalCnaeError('');
      return;
    }

    // con longitud completa, validamos el código
    const selectedValue = allCnae.find(
      (item: any) => (item.Codigo || "").toString().trim() === value
    );
    if (selectedValue) {
      setValue(idDescription, selectedValue.Descripcion || "");
      try { clearErrors && clearErrors(idCode); } catch (e) {}
      try { clearErrors && clearErrors(idDescription); } catch (e) {}
      setLocalCnaeError('');
    } else {
      // código completo pero no existe: limpiamos descripción y código
      setValue(idDescription, "");
      setValue(idCode, "");
      const errorMessage = `${value} CNAE no existe`;
      try { setError && setError(idCode, { type: 'manual', message: errorMessage }); } catch (e) {}
      setLocalCnaeError(errorMessage);
    }
  };

  const setValueCnaeDescription = () => {
    if (allCnae && watchCnaeCode) {
      const descriptionValue = allCnae.find(
        (item: any) => item.Codigo === watchCnaeCode
      );
      if (descriptionValue) {
        setValue(idDescription, descriptionValue.Descripcion);
        try { clearErrors && clearErrors(idCode); } catch (e) {}
        try { clearErrors && clearErrors(idDescription); } catch (e) {}
        setLocalCnaeError('');
      }
    }
  }

  const itemsData: { [key: string]: Object }[] = allCnae;
  const fields: object = { value: "Descripcion" };

  function onFiltering(e: any) {
    const options = {
      keys: ["Descripcion"],
      includeMatches: true,
      findAllMatches: true,
    };

    const fuse = new Fuse(itemsData, options);
    const result = fuse.search(e.text);
    const data = result.map((res: any) => res.item);

    e.updateData(data, undefined);

    const lists = document
      ?.getElementById("agreement_popup")
      ?.querySelectorAll(".e-list-item");

    if (lists) {
      highlightSearch(Array.from(lists), result);
    }
  }

  function highlightSearch(listItems: Element[], result: any): void {
    if (result.length > 0) {
      for (let i = 0; i < listItems.length; i++) {
        let innerHTML = listItems[i].innerHTML;
        for (let j = result[i].matches[0].indices.length - 1; j >= 0; j--) {
          const indexes = result[i].matches[0].indices[j];
          innerHTML =
            innerHTML.substring(0, indexes[0]) +
            '<span class="e-highlight">' +
            innerHTML.substring(indexes[0], indexes[1] + 1) +
            "</span>" +
            innerHTML.substring(indexes[1] + 1);
          listItems[i].innerHTML = DOMPurify.sanitize(innerHTML);
        }
      }
    }
  }

  return (
    <fieldset
      className={`input-block input-block--code ${
        (errors && errors[idCode]?.message) || (errors && errors[idDescription]?.message)
          ? "error"
          : ""
      }`}
    >
      <div className="container-leyend">
        <legend className="input-block--code__legend">
          {label ? label : "CNAE para cotización AT/EP"}
        </legend>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-3 col-lg-3">
        <input
          className=""
          type="text"
          name={idCode}
          id={idCode}
          {...register(idCode)}
          maxLength={4}
          minLength={4}
          onChange={handleInputChange}
        />
        </div>
        {itemsData.length > 0 ? (
          <div className=" col-sm-12 col-md-9 delta-autocomplete">
            <AutoCompleteComponent
              change={handleChange}
              id={idDescription}
              name={idDescription}
              dataSource={itemsData}
              filtering={onFiltering}
              fields={fields}
              placeholder={placeholder ? placeholder :"CNAE para cotización AT/EP"}
              autofill={true} 
              {...register(idDescription, {
                required: required
                  ? typeof required === "string"
                    ? required
                    : "Este campo es obligatorio"
                  : false,
              })}
              popupHeight="250px"
              popupWidth="250px"
              onBlur={() => {
                const value = getValues(idDescription);
                if (value === "") {
                  setValue(idCode, "");
                }
              }}
            />
          </div>
        ) : null}
      </div>
      {(errors && errors[idCode]?.message) || localCnaeError ? (
        <p className="error m-0">{errors?.[idCode]?.message || localCnaeError}</p>
      ) : null}
    </fieldset>
  );
};

export default CnaeContributionAtEp;
